import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Info } from './styles';

export interface AutoInfoData {
  passengers: string;
  luggage: string;
  airConditioned: boolean;
  doors: string;
  transmission: string;
  unlimitedMileage?: boolean;
}

export interface Props {
  data: AutoInfoData;
  showAirConditioned: boolean;
  full?: boolean;
  mini?: boolean;
}

const AutoInfo = ({ data, showAirConditioned, full = false, mini = false }: Props) => {
  const { t } = useStoreTranslation();
  const { passengers, luggage, airConditioned, doors, transmission, unlimitedMileage = false } = data;
  return (
    <Info $full={full}>
      <Info.Item $full={full} $mini={mini}>
        <Info.Icon src="/corporate/images/autos/icon-person-outline.svg" />
        <span>{passengers}</span>
      </Info.Item>
      <Info.Item $full={full} $mini={mini}>
        <Info.Icon src="/corporate/images/autos/icon-packages.svg" />
        <span>{luggage}</span>
      </Info.Item>
      {showAirConditioned ? (
        <Info.Item $full={full} $mini={mini}>
          <Info.Icon src="/corporate/images/autos/icon-freeze.svg" />
          <span>{t(`autosDetails.airConditioned.${airConditioned}`)}</span>
        </Info.Item>
      ) : null}
      <Info.Item $full={full} $mini={mini}>
        <Info.Icon src="/corporate/images/autos/icon-doors.svg" />
        <span>{doors}</span>
      </Info.Item>
      <Info.Item $full={full} $mini={mini}>
        <Info.Icon src="/corporate/images/autos/icon-transmission.svg" />
        <span>{t(`autosCard.category.transmission.${transmission.toUpperCase()}`)}</span>
      </Info.Item>
      {unlimitedMileage && (
        <Info.Item $full={full} $mini={mini}>
          <Info.Icon src="/corporate/images/autos/icon-km.svg" />
          <span>{t('autosFilter.unlimitedMileage')}</span>
        </Info.Item>
      )}
    </Info>
  );
};

export default AutoInfo;
